// Сгенерировано scripts/gen-indexes.ts (`pnpm gen`). Не править: файл пересоздаётся.

import type { PageRoute } from './page-route';
import { route as page_AdminAgentData } from './pages/AdminAgentData/route';
import { route as page_Assistant } from './pages/Assistant/route';
import { route as page_Brigades } from './pages/Brigades/route';
import { route as page_BrigadierList } from './pages/BrigadierList/route';
import { route as page_HrList } from './pages/HrList/route';
import { route as page_Login } from './pages/Login/route';
import { route as page_MyAgents } from './pages/MyAgents/route';
import { route as page_OAuthInteraction } from './pages/OAuthInteraction/route';
import { route as page_Personnel } from './pages/Personnel/route';
import { route as page_Rules } from './pages/Rules/route';
import { route as page_RulesPrint } from './pages/RulesPrint/route';
import { route as page_Settings } from './pages/Settings/route';
import { route as page_Timesheet } from './pages/Timesheet/route';

/** Страницы из `web/src/pages/<путь>/route.ts` на любой глубине. Порядок не важен: react-router выбирает по пути. */
export const pageRoutes: readonly PageRoute[] = [
  page_AdminAgentData,
  page_Assistant,
  page_Brigades,
  page_BrigadierList,
  page_HrList,
  page_Login,
  page_MyAgents,
  page_OAuthInteraction,
  page_Personnel,
  page_Rules,
  page_RulesPrint,
  page_Settings,
  page_Timesheet,
];
